import { useEffect } from 'react';
import { GetContextActionsRequestBody } from 'models/contextActions';
import {
  ContextActions,
  DispatcherEntityTypeCode,
  EAIEntityTypeCode
} from 'utils/constants';
import { fetchAndSetEaiContextActions } from 'features/eai/thunks';
import { fetchAndSetDispatcherContextActions } from 'features/dispatcher/thunks/dispatcherThunks';
import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import {
  selectAccountInfo,
  selectSelectedEmsMemberAccount
} from 'features/account/accountSelectors';

const {
  CA_EAI_ACCESS_USER_PAGE,
  CA_EAI_ACCESS_PARTY_PAGE,
  CA_EAI_ACCESS_BALANCING_GROUP_PAGE,
  CA_EAI_ACCESS_DELIVERY_POINT_PAGE,
  CA_EAI_ACCESS_DEVICE_PAGE,
  CA_EAI_ACCESS_DELIVERY_CONTRACT_PAGE
} = ContextActions.EAI;

const {
  CA_DISP_ACCESS_ONLINE_DISPATCHING_PAGE,
  CA_DISP_ACCESS_PRODUCTION_PLAN_PAGE,
  CA_DISP_ACCESS_CONSUMPTION_PLAN_PAGE,
  CA_DISP_ACCESS_OPERATION_CALENDAR_PAGE,
  CA_DISP_ACCESS_SYSTEM_IMBALANCE_EVALUATION_PAGE,
  CA_DISP_ACCESS_DELIVERY_POINT_PRODUCTION_PLAN_EVALUATION_PAGE,
  CA_DISP_ACCESS_DEVICE_PRODUCTION_PLAN_EVALUATION_PAGE,
  CA_DISP_ACCESS_BALANCING_GROUP_EVALUATION_PAGE,
  CA_DISP_ACCESS_REPORTING_PAGE,
  CA_DISP_ACCESS_EVENT_OVERVIEW_PAGE,
  CA_DISP_ACCESS_H_PLUS_X_SI_PAGE,
  CA_DISP_ACCESS_RESERVED_CAPACITY_PAGE
} = ContextActions.DISPATCHER;

const { CA_DISP_ACCESS_ECONOMIC_BENEFIT_EVALUATION_PAGE } =
  ContextActions.REPORTING;

// ==============================|| HOOK ||============================== //

const useFetchAndSetSidebarCA = () => {
  const dispatch = useAppDispatch();
  const accountInfo = useAppSelector(selectAccountInfo);
  const selectedEmsMemberAccount = useAppSelector(
    selectSelectedEmsMemberAccount
  );

  useEffect(() => {
    if (accountInfo?.sub && selectedEmsMemberAccount) {
      let requestBody: GetContextActionsRequestBody = [
        {
          resourceEntity: EAIEntityTypeCode.USER,
          identificators: [accountInfo.sub],
          contextActions: [
            CA_EAI_ACCESS_USER_PAGE,
            CA_EAI_ACCESS_PARTY_PAGE,
            CA_EAI_ACCESS_BALANCING_GROUP_PAGE,
            CA_EAI_ACCESS_DELIVERY_POINT_PAGE,
            CA_EAI_ACCESS_DEVICE_PAGE,
            CA_EAI_ACCESS_DELIVERY_CONTRACT_PAGE
          ]
        }
      ];

      dispatch(fetchAndSetEaiContextActions(requestBody));

      requestBody = [
        {
          resourceEntity: EAIEntityTypeCode.USER,
          identificators: [accountInfo.sub],
          contextActions: [
            CA_DISP_ACCESS_ONLINE_DISPATCHING_PAGE,
            CA_DISP_ACCESS_PRODUCTION_PLAN_PAGE,
            CA_DISP_ACCESS_CONSUMPTION_PLAN_PAGE,
            CA_DISP_ACCESS_OPERATION_CALENDAR_PAGE,
            CA_DISP_ACCESS_SYSTEM_IMBALANCE_EVALUATION_PAGE,
            CA_DISP_ACCESS_DELIVERY_POINT_PRODUCTION_PLAN_EVALUATION_PAGE,
            CA_DISP_ACCESS_DEVICE_PRODUCTION_PLAN_EVALUATION_PAGE,
            CA_DISP_ACCESS_BALANCING_GROUP_EVALUATION_PAGE,
            CA_DISP_ACCESS_REPORTING_PAGE,
            CA_DISP_ACCESS_EVENT_OVERVIEW_PAGE,
            CA_DISP_ACCESS_RESERVED_CAPACITY_PAGE,
            CA_DISP_ACCESS_ECONOMIC_BENEFIT_EVALUATION_PAGE
          ]
        }
      ];

      if (selectedEmsMemberAccount.balancingGroupId) {
        requestBody.push({
          resourceEntity: DispatcherEntityTypeCode.BALANCING_GROUP,
          identificators: [selectedEmsMemberAccount.balancingGroupId],
          contextActions: [CA_DISP_ACCESS_H_PLUS_X_SI_PAGE]
        });
      }

      dispatch(fetchAndSetDispatcherContextActions(requestBody));
    }
  }, [accountInfo, dispatch, selectedEmsMemberAccount]);
};

export default useFetchAndSetSidebarCA;
